<template>
  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'UserAccessList' }">User Access</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-tabs v-model="active_tab" type="card">

      <el-tab-pane label="Details" name="details">
        <el-form
          ref="user_access"
          :model="user_access"
          :rules="rules.user_access"
          :label-position="label_position">

          <el-form-item label="Name" prop="name">
            <el-input v-model="user_access.name"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="updateUserAccess('user_access')">Update</el-button>
          </el-form-item>

        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Permissions" name="permissions">
        <el-card 
          hover="never"
          :body-style="{ padding: '0px' }">
            <div slot="header" class="clearfix">
              <el-row>
                <el-col :span="16">
                  <el-input
                  :clearable="true"
                  placeholder="Filter Permissions"
                  prefix-icon="el-icon-search"
                  v-model="filter_roles"></el-input>
                </el-col>
                <el-col :span="6" :offset="2" class="text-right">
                  <el-button @click="assignRoles()">Assign Roles</el-button>
                </el-col>
              </el-row>
            </div>
            <div class="scroll-pane">
              <el-checkbox-group v-model="selected_roles">
                <el-checkbox v-for="item in filteredRoles" :label="item.id" :key="item.id" class="checkbox-list">{{item.display_name}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-card>
        </el-tab-pane>
    </el-tabs>

    <pre>{{$data}}</pre>
  </div>
</template>

<style scoped>

  .checkbox-list {
    display:block;
    margin: 0 0 5px 0;
    padding: 0;
  }

  ul.sync-list {
    padding:0;
    margin:0;
    list-style: none;
  }

  ul.sync-list li {
    margin:10px 0 10px 0;
  }

  .button_card {
    text-align: center;
    margin-top: 20px;
  }

</style>

<script>
  import Config from '@/store/Config.js';
  import Utils from '@/components/utils/Utils.js';
  import Auth from '@/components/auth/AuthCheck.js';
  import store from '@/store/Store.js';

  export default {
    data: function() {
      return { 
        page_alias: 'User Access Edit',
        page_slug: 'user-access-edit',
        
        permissions: store.permissions,
        config: Config.config,

        loading: true,
        label_position: 'top',
        active_tab: 'details',

        user_access: {},

        roles: [],
        selected_roles: [], 
        filter_roles: '',

        rules: {
          user_access: {
            name: [
              {required: true, message: 'Please Enter Name', trigger: 'blur'}
            ]
          }
        }
      };
    },

    mounted: function() {
      const me = this;
      me.jwt = Utils.decodejwt();

      me.getUserAccess();
      me.getRoles();
    },

    computed: {
      filteredRoles() {
        const me = this;
        return me.roles.filter(function(e){return e.display_name.toLowerCase().indexOf(me.filter_roles.toLowerCase())>=0;});
      }
    },

    methods: {
      /* FIRST TAB */
      getUserAccess: function() {
        console.log('Get User Access Function');
        const me = this;

        me.$http.get(me.config.api + 'access/{id}', {params: {id: me.$route.params.id}}).then(
        response => {
          console.log('Get User Access Function - Success Getting Data');

          me.user_access = response.body.data;

          me.selected_roles = me.user_access.user_roles.map(a => a.id);

          me.loading = false;
        }, response => {
          console.log('Get User Access Function - Error Getting Data');

          me.loading = false;
        });
      },

      updateUserAccess: function(formName) {
        console.log('Update User Access Function');
        const me = this;

        me.$refs[formName].validate((valid) => {
          if(valid) {
            me.$http.put(me.config.api + 'access/{id}', me.user_access, {params: {id: me.$route.params.id}}).then(
              response => {
              console.log('Update User Access Function - Success Putting Data');

              me.getUserAccess();

              me.$notify({
                title: 'Success',
                message: 'The User Access Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Update User Access Function - Error Putting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },
      /* END FIRST TAB */

      /* SECOND TAB */
      getRoles: function() {
        console.log('Get Roles Function');
        const me = this;

        me.$http.get(me.config.api + 'roles').then(
          response => {
          console.log('Get Roles Function - Success Getting Data');

          me.roles = response.body.data;
        }, response => {
          console.log('Get Roles Function - Error Getting Data');
        });
      },

      assignRoles: function() {
        const me = this;
        console.log('Assign Roles Function');

        me.$http.post(me.config.api + 'access/{id}/roles', me.selected_roles, {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('Assign Roles Function - Success Posting Data');  

          me.getRoles();
          me.getUserAccess();

          me.filter_roles = '';

          me.$notify({
            title: 'Success',
            message: 'This Roles Were Assigned',
            type: 'success'
          });                
        }, response => {
          console.log('Assign Roles Function - Error Posting Data');
        });
      }
      /* END SECOND TAB */
    }
  }
</script>





// WEBPACK FOOTER //
// src/pages/user-access/UserAccessEdit.vue